function getOs() {
    const os = ['Windows','Mac', 'Android', 'Ios', 'Linux']; // add your OS values
    const userOs = os.find(v=>navigator.appVersion.indexOf(v) >= 0);
    return userOs || 'Windows';
}
const OsObject = {
    Windows: {
        label: 'Windows',
        headerText: 'VPN Nederland voor Windows downloaden',
        captionText: ' iOS, Android, Mac',
        buttonText: ' Windows',
        img: 'Windows',
        icon: 'game-icons:pc',
        downloadLink: "https://update.vpnnederland.nl/windows/VPNNederland-Setup.exe"

    },
    Mac: {
        label: 'Mac',
        headerText: 'VPN Nederland voor Mac downloaden',
        captionText: ' iOS, Android, Windows',
        buttonText: ' Mac',
        img: 'Mac',
        icon: 'ic:outline-laptop-mac',
        downloadLink: "https://update.vpnnederland.nl/mac/VPNNederland-MacOS-setup.pkg"
    },
    Android: {
        label: 'Android',
        headerText: 'VPN Nederland voor Android downloaden',
        captionText: ' iOS, Mac, Windows',
        buttonText: ' Android',
        img: 'Android',
        icon: 'ic:outline-tablet-android',
        downloadLink: 'https://play.google.com/store/apps/details?id=com.curuno.vpnnederland'
    },
    iOS: {
        label: 'iOS',
        headerText: 'VPN Nederland voor Ios downloaden',
        captionText: ' Android, Mac, Windows',
        buttonText: 'iOS',
        img: 'iOS',
        icon: 'wpf:iphone',
        downloadLink: 'https://apps.apple.com/nl/app/vpn-nederland/id1450814725'
    },
    Linux: {
        label: 'Linux',
        headerText: 'VPN Nederland voor Linux downloaden',
        captionText: ' Android, Mac, Windows',
        buttonText: 'Linux',
        // buttonTextSecondary: 'Linux',
        img: 'Windows',
        icon: 'arcticons:pc-creator',
        downloadLink: 'https://update.vpnnederland.nl/linux/vpnnederland_2.1.140_amd64.deb',
        downloadLinkSecondary: 'https://update.vpnnederland.nl/linux/vpnnederland_2.1.140_amd64.deb'
    },
    ManualOpenVpn: {
        label: 'Manual Setup',
        headerText: 'VPN Nederland voor Manual downloaden',
        captionText: ' Android, Mac, Windows, Linux',
        buttonText: null,
        // buttonTextSecondary: 'Linux',
        img: 'Windows',
        icon: 'arcticons:pc-creator',
        downloadLink: 'https://update.vpnnederland.nl/linux/vpnnederland_2.1.140_amd64.deb',
        downloadLinkSecondary: 'https://update.vpnnederland.nl/linux/vpnnederland_2.1.140_amd64.deb'
    }
}

export {getOs, OsObject}
